import { ArrowUpRight } from "lucide-react";

const WEBSITE_URL = "https://www.wearetheweave.co.uk";

export default function LearnMoreCTA() {
  return (
    <a
      href={WEBSITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="weave-learn-more group block"
      data-testid="learn-more-cta"
    >
      <div>
        <p className="text-[11px] uppercase tracking-[0.22em] font-medium" style={{ color: "#3c8386" }}>
          Beyond AWAKE
        </p>
        <h3 className="mt-2 text-2xl md:text-3xl font-light text-slate-800 tracking-tight leading-snug">
          Want to learn more about what we do?
        </h3>
        <p className="mt-2 text-slate-500 text-sm md:text-base">
          Step inside The Weave — community, programmes, and the people doing the work.
        </p>
      </div>
      <span
        className="weave-btn-primary flex-shrink-0"
        style={{ pointerEvents: "none" }}
        data-testid="learn-more-btn"
      >
        wearetheweave.co.uk
        <ArrowUpRight size={16} />
      </span>
    </a>
  );
}
